import React, { useState } from "react";
import { View, TouchableOpacity, Image, Platform } from "react-native";
import PtIcon from "../core/pt-icon/pt-icon";
import PtText from "../core/pt-text/pt-text";
import { styles } from "./pt-add-pwa-to-home-screen-ios-styles";
import { getTranslation } from "../../helpers/getTranslation";

export default function PtAddPwaToHomeScreenIos(props: any) {

  const addToHomeScreenMessage = props.message || getTranslation('ios.add.to.home.screen.message') || 'To install this app on your iPhone: Tap %s icon and then choose "Add to Homescreen" from the menu';

  const prepareMessage = () => {
    const messageParts = addToHomeScreenMessage.split('%s');
    return { beforeIcon: messageParts[0], afterIcon: messageParts[1] };
  }

  // Detects if device is on iOS
  const isIos = () => {
    if (Platform.OS === 'web') {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    }
    return false;
  }
  // Detects if device is in standalone mode
  const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

  const [showPopup, setShowPopup] = useState(isIos() && !isInStandaloneMode());

  const removePopup = () => {
    setShowPopup(false);
  }

  return (
    <>
      {showPopup ?
        <View style={[styles.popupContainer]}>
          <View style={[styles.popupWrapper]}>
            <View style={[styles.closeButtonContainer]}>
              <TouchableOpacity onPress={removePopup}>
                <PtIcon iconName={'close'} iconSize={24} />
              </TouchableOpacity>
            </View>
            <View style={[styles.messageContainer]}>
              <PtText style={[styles.messageText]}>
                {prepareMessage().beforeIcon}
                <Image source={require('../../assets/images/ios-share-icon.png')} style={[styles.messageIconImage]} />
                {prepareMessage().afterIcon}
              </PtText>
            </View>
          </View>
        </View>
        : null
      }
    </>
  )

}